@if (title || subTitle) {
  @if (title) {
    <title [direction]="titleDir" [style]="titleStyle">{{ title }}</title>
  }
  @if (subTitle) {
    <sub-title [direction]="subTitleDir" [style]="subTitleStyle">
      {{ subTitle }}
    </sub-title>
  }
}
